var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeaver14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1056,
    height: 1086,
    viewBox: "0 0 1056 1086",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.73 230.752C281.327 230.436 299.855 228.576 311.934 227.372C323.551 226.214 329.413 224.097 335.232 223.636C337.99 223.418 340.761 222.862 384.304 222.345C426.478 221.843 509.426 222.169 552.989 222.05C596.551 221.931 598.217 221.693 607.214 221.57C616.211 221.447 632.488 221.447 641.698 221.533C650.908 221.618 652.557 221.789 663.522 221.877C674.487 221.965 694.718 221.965 714.586 222.062C734.454 222.158 753.347 222.351 763.867 222.759C779.512 223.366 785.423 225.959 794.251 227.006C800.146 227.705 810.888 228.901 821.449 228.782C824.34 228.749 822.211 228.425 800.943 224.122C779.674 219.819 739.329 211.458 713.477 207.151C687.625 202.844 677.488 202.844 671.433 202.725C665.378 202.606 663.712 202.368 629.945 202.245C596.177 202.123 530.359 202.123 495.453 201.238C460.547 200.354 458.549 198.586 456.568 196.97C452.755 193.856 450.096 191.581 448.875 189.405C444.739 182.034 449.102 168.252 453.027 157.531C456.736 147.4 462.372 141.846 467.318 138.324C476.07 132.093 495.108 128.899 504.607 125.981C516.577 122.304 524.601 123.522 544.126 121.236C576.443 117.451 588.293 122.828 594.197 126.454C606.18 133.812 607.308 140.042 613.135 145.7C617.49 149.929 617.501 156.823 617.804 161.427C617.962 163.826 615.968 166.339 613.374 168.502C612.164 169.511 610.772 169.81 601.102 170.972C591.433 172.134 573.428 174.014 554.989 174.632C536.551 175.249 518.226 174.547 507.257 173.88C493.2 173.025 480.227 171.666 464.468 171.106C456.908 170.838 454.089 170.46 452.074 169.877C451.055 169.582 450.578 168.127 451.037 166.947C453.68 160.149 465.117 158.693 495.531 153.39C524.929 148.264 544.69 152.041 548.319 153.056C550.299 153.536 552.558 153.945 557.379 154.156C562.2 154.366 569.515 154.366 577.051 154.366",
    stroke: "#F55E34",
    strokeWidth: 44,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M499.198 722.197C514.697 754.752 523.15 774.125 533.873 786.271C541.189 794.557 552.416 813.701 558.91 826.428C563.054 834.549 565.389 846.035 566.634 860.267C569.322 891.013 562.947 900.518 553.939 913.857C542.89 930.217 530.101 932.944 520.544 934.428C509.697 936.113 500.658 923.993 494.609 918.246C486.076 910.139 484.402 892.505 482.979 879.155C482.405 873.779 478.913 860.552 475.847 835.959C474.144 822.304 474.804 806 476.948 790.472C481.124 760.221 490.339 740.428 496.304 726.143C504.902 705.555 508.859 689.844 509.233 684.86C509.393 682.737 508.101 681.447 492.302 680.782C476.502 680.117 445.879 680.117 428.091 679.746C399.213 679.143 389.565 674.463 380.145 673.397C365.726 671.766 357.039 669.991 349.004 663.755C336.125 653.759 337.992 638.917 337.4 623.271C336.956 611.513 352.611 582.373 362.492 563.334C369.65 549.543 374.464 541.551 384.963 523.76C390.032 515.17 393.392 508.763 407.368 483.534C416.622 466.83 419.941 453.434 426.556 434.476C430.808 422.291 434.4 413.012 436.036 403.926C437.258 397.136 437.245 387.388 437.55 350.649C437.654 338.089 432.741 333.88 432.543 331.382C431.925 323.552 451.476 320.637 461.649 311.927C464.64 309.367 468.963 307.782 476.05 306.677C484.995 305.282 512.38 304.396 547.665 304.702C568.06 304.88 575.122 310.732 582.501 315.004C590.554 319.668 602.496 319.786 611.044 320.518C619.512 321.243 596.851 326.517 594.467 328.53C593.306 329.511 593.256 331.362 593.595 333.216C595.039 341.097 602.007 345.268 606.356 352.746C616.132 369.556 611.921 378.431 615.222 386.771C618.699 395.556 624.357 411.215 628.033 422.797C631.718 434.411 635.802 449.936 639.809 462.686C643.958 475.89 647.206 488.054 649.044 498.258C651.353 511.072 661.812 541.159 672.369 563.532C677.382 574.155 686.543 581.148 692.797 591.419C699.589 602.573 695.303 622.153 693.247 632.994C691.852 640.354 687.342 647.013 680.854 653.316C670.339 663.532 648.534 658.119 626.851 658.786C599.179 659.638 564.769 660.861 554.063 660.944C543.922 661.022 534.376 656.248 518.172 647.91C490.972 633.914 469.852 612.92 456.78 604.453C451.183 600.828 450.103 595.388 449.426 579.243C448.75 563.097 449.128 535.6 449.478 520.497C450.026 496.905 451.972 481.398 453.472 463.574C456.326 429.653 464.66 415.209 470.051 407.499C472.04 404.655 474.454 401.519 479.388 398.728C486.696 394.593 499.352 396.305 510.538 396.994C517.398 397.417 521.292 402.208 525.288 405.854C527.299 407.689 528.939 409.845 537.421 435.988C545.903 462.132 561.091 512.288 568.915 543.861C579.438 586.324 576.427 600.594 575.115 604.692C574.371 607.014 572.435 609.434 570.376 611.119C568.317 612.804 565.928 613.578 561.978 612.894C538.7 600.069 519.995 581.709 516.674 576.889C515.24 574.711 514.314 573.076 511.99 570.477",
    stroke: "#8C7868",
    strokeWidth: 130,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.658 621.624C108.371 621.218 116.083 620.811 142.698 620.602C169.314 620.393 214.599 620.393 267.658 619.624",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M318.042 712.351C308.349 707.002 287.58 687.968 280.919 676.088C273.713 663.236 272.807 650.984 272.658 609.991C272.593 591.844 287.416 570.236 302.936 537.255C311.84 518.334 327.758 501.199 335.668 491.163C346.057 477.982 350.175 460.407 354.972 447.174C360.199 432.759 368.878 399.265 372.049 381.162C374.263 368.526 377.328 354.081 383.255 327.884C389.205 301.588 405.039 290.22 436.803 265.024C456.74 249.209 467.716 248.614 513.304 241.751C561.278 234.53 581.492 247.518 595.608 253.594C610.548 260.025 622.842 271.407 636.94 283.506C656.653 300.424 665.568 320.545 673.219 346.025C678.827 364.701 681.885 380.924 683.433 396.233C684.895 410.702 690.406 425.436 692 456.534C692.921 474.492 700.526 495.559 707.422 509.374C714.155 522.864 724.486 532.852 736.681 552.823C750.126 574.841 755.694 594.733 757.309 609.556C762.729 659.321 750.683 676.893 741.36 689.047C734.722 697.7 724.607 701.806 717.697 704.582C710.92 707.304 678.873 712.096 634.139 718.178C614.4 720.862 597.483 720.638 575.028 721.644C561.081 722.269 535.228 723.94 500.234 723.571C486.312 723.425 480.198 722.466 453.546 722.086C426.893 721.706 379.892 721.706 354.398 721.383C328.903 721.059 326.339 720.413 323.042 719.746",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M733.658 694.624H732.658",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M428.462 720.624C427.986 737.463 423.76 755.234 419.309 772.216C415.305 787.493 419.525 806.034 422.063 821.72C424.845 838.914 430.158 863.722 431.94 900.582C432.88 920.035 435.368 930.926 439.505 942.414C445.307 958.531 460.731 964.886 502.805 984.992C523.202 994.74 544.16 989.967 556.879 984.632C567.672 980.105 574.057 969.177 584.406 955.779C593.053 944.585 603.535 933.909 608.241 915.968C617.15 882.007 605.956 866.223 604.815 834.596C604.28 819.759 595.462 809.586 588.564 793.756C584.106 783.522 567.738 777.842 556.576 760.446C547.55 744.488 543.429 736.257 540.242 729.982C538.868 726.998 537.989 724.422 535.527 721.768",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6582 797.624C114.035 797.624 131.411 797.624 177.195 797.624C222.979 797.624 296.643 797.624 336.055 797.216C378.395 795.993 384.027 794.185 389.31 792.455C391.975 791.693 394.611 791.167 399.658 790.624",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M582.658 785.624C613.851 785.624 645.044 785.624 694.911 785.624C744.778 785.624 812.375 785.624 848.717 785.954C885.059 786.284 888.098 786.944 892.008 787.284C895.918 787.624 900.606 787.624 904.658 787.624",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M755.658 584.624C767.3 585.103 778.943 585.582 794.116 586.132C809.29 586.681 827.642 587.286 849.819 588.045C871.996 588.805 897.442 589.701 923.658 590.624",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M403.658 788.624H410.658",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M388.932 303.624C386.615 300.515 382.688 294.613 382.658 290.516C382.643 288.45 384.611 286.622 386.965 285.241C392.508 283.036 401.039 282.186 409.806 282.838C413.329 283.489 414.969 284.791 416.658 286.747",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M656.658 300.171C661.157 297.632 667.408 296.323 674.375 296.683C679.537 296.949 683.459 299.659 686.292 303.076C689.943 307.479 685.463 313.982 682.34 317.761C680.312 319.652 677.383 321.485 674.898 322.867C672.412 324.249 670.459 325.124 667.818 326.624",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.658 522.85C122.182 518.056 125.471 513.938 132.88 510.995C159.687 500.348 191.771 520.165 208.159 523.556C212.644 524.484 213.701 515.672 216.84 511.605C219.604 508.025 226.122 507.321 232.836 507.726C242.939 508.335 248.96 517.642 260.482 517.763C271.185 514.165 278.444 510.684 284.981 510.785C289.203 511.648 295.259 514.157 303.658 516.144",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M221.658 449.624C221.658 447.726 226.316 443.351 235.099 438.556C247.919 431.558 260.768 445.763 269.731 447.483C273.88 448.279 276.573 442.675 279.488 438.715C286.72 428.891 303.343 439.547 312.074 441.871C315.573 439.868 319.522 438.566 324.392 439.182C327 439.493 329.887 439.799 335.658 440.764",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.658 376.03C123.738 370.215 159.084 374.25 171.676 381.248C175.601 383.429 178.58 375.574 181.162 371.971C191.328 370.283 201.869 375.075 210.25 379.527C213.787 380.916 215.87 380.54 220.658 378.465",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M696.658 393.624C698.845 392.017 704.804 387.604 713.47 382.067C726.465 373.764 753.328 387.628 766.272 385.605C771.854 384.733 773.764 377.786 778.093 376.631C789.671 373.543 800.257 383.192 817.859 383.213C838.179 383.237 851.877 377.598 866.324 380.178C872.946 381.36 879.285 374.808 885.51 371.142C891.792 369.5 905.76 371.919 923.083 376.176C929.666 377.707 931.764 377.96 939.658 375.921",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M693.658 435.581C698.148 432.713 705.982 429.349 716.873 427.279C737.246 423.406 751.711 438.105 764.813 435.148C772.351 433.447 777.601 428.547 783.771 429.178C797.766 430.611 806.523 438.332 818.447 437.572C826.606 437.051 833.545 431.06 839.722 429.36C845.043 428.782 849.31 430.028 853.662 432.899C856.243 434.523 859.579 436.486 865.658 436.241",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M815.658 495.624C823.829 490.912 838.547 487.127 855.357 485.624C866.786 489.155 875.268 492.912 885.996 491.938C889.155 491.934 893.003 492.655 899.658 493.397",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M957.383 587.189H979.946",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M947.132 777.262C950.723 777.262 954.314 777.262 958.062 777.161C961.81 777.059 965.606 776.857 969.517 776.647",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6684 628.68C60.4654 628.68 60.2625 628.68 58.9562 628.513C57.6499 628.347 55.2463 628.014 48.1721 627.842C41.0979 627.671 29.426 627.671 17.4004 627.671",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6582 792.696C67.2972 792.696 65.9362 792.696 58.5805 792.696C51.2248 792.696 37.9157 792.696 29.0178 792.341C20.1199 791.986 16.0365 791.277 7.2627 790.546",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.562 753.063C81.4306 752.774 82.2993 752.484 85.5991 752.19C88.8989 751.896 94.6037 751.607 100.481 751.309",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.809 701.086L110.761 700.34",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M174.477 717.269V719.376",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M712.284 742.007H735.192",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M791.546 721.285C791.749 721.285 791.952 721.285 797.054 721.285C802.156 721.285 812.151 721.285 823.941 720.539",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M836.878 677.916C837.081 677.713 837.284 677.51 840.633 676.573C843.982 675.635 850.47 673.969 857.156 672.253",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M938.409 677.484C937.018 675.804 935.627 674.124 935.345 672.289C935.063 670.453 935.932 668.513 937.682 666.935C941.503 663.489 947.272 663.251 951.749 664.485C953.838 665.062 954.909 667.197 955.195 669.113C955.482 671.029 954.786 673.085 953.313 674.579C951.84 676.073 949.611 676.941 947.462 677.635C945.314 678.329 943.315 678.821 941.255 679.328",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204.038 730.159C204.443 729.753 206.565 728.646 210.427 727.901C212.346 727.53 214.302 729.284 215.294 731.033C216.286 732.782 216.286 735.012 215.185 736.711C214.084 738.41 211.882 739.511 209.612 737.047",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 863.752C123.326 863.346 122.66 857.055 121.651 846.711C121.236 842.454 121.308 840.189 131.52 839.025C161.983 835.553 193.92 838.194 211.272 838.843C232.288 839.63 261.083 840.153 274.785 841.796C296.923 844.45 315.14 844.41 357.732 848.907C366.934 849.878 365.955 861.636 366.078 867.093C366.201 872.551 366.447 874.723 335.834 875.944C305.221 877.165 243.742 877.368 210.955 877.204C178.169 877.041 175.94 876.505 167.016 876.229C158.093 875.953 142.543 875.953 123.801 875.338",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.341 934.013C129.341 932.043 129.63 926.366 131.227 918.853C132.312 913.753 156.747 914.179 188.781 914.512C221.627 914.853 261.014 916.776 281.679 918.132C310.001 919.989 326.255 921.16 341.036 922.362C346.316 922.791 346.602 925.967 347.122 928.305C348.139 932.874 348.906 937.718 347.625 942.014C347.018 944.046 343.78 944.399 314.09 944.757C284.4 945.116 227.662 945.116 196.825 944.949C165.989 944.783 162.774 944.45 157.425 944.278C152.076 944.106 144.691 944.106 137.081 944.106",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.811 1016.12C119.725 1013.31 119.638 1010.5 119.203 1007.34C118.767 1004.19 117.985 1000.77 128.14 998.979C158.988 993.543 184.378 997.449 214.661 998.02C241.725 998.53 292.554 998.214 319.041 999.763C345.528 1001.31 346.137 1004.41 346.349 1007.05C346.561 1009.69 346.358 1011.78 345.355 1013.4C344.352 1015.03 342.556 1016.13 320.786 1016.69C299.017 1017.26 257.329 1017.26 227.641 1017.39C161.42 1018.63 152.867 1020.3 148.475 1021.06C146.169 1021.41 143.707 1021.7 136.079 1022.75",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M145.556 1080.8C145.556 1078.17 145.556 1075.53 146.569 1073.7C148.564 1070.1 154.22 1069.54 170.37 1068.9C208.63 1067.4 247.104 1069.02 272.726 1069.71C311.331 1070.76 320.15 1069.83 328.719 1068.47C333.254 1067.84 338.711 1067.39 343.632 1068.36C345.481 1069.52 346.017 1072.07 347.184 1078.39",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7715 246.519C16.8574 246.519 18.9433 246.519 23.653 246.519C28.3626 246.519 35.6329 246.519 42.2016 247.011C48.7704 247.503 54.4174 248.488 60.2355 249.503",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M111.072 251.653H128.886",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M221.613 253.672H246.184",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M306.368 252.794H307.598",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M442.861 252.396H454.184",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M646.817 256.039C654.153 256.039 661.488 256.039 668.658 255.937C675.827 255.836 682.607 255.633 689.593 255.424",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M738.242 256.039C747.527 256.039 756.812 256.039 763.219 255.807C769.626 255.575 772.874 255.111 776.22 254.633",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M804.225 254.633H830.065",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M928.015 247.295H948.39",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M984.389 246.286H1010.84",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M251.836 232.222C251.836 230.745 251.836 229.268 252.575 227.645C257.283 217.3 278.648 217.2 289.527 215.338C306.142 212.494 328.871 213.167 344.626 211.806C360.589 210.427 400.299 207.427 429.09 205.55C434.786 205.179 439.012 203.451 442.274 201.781C450.033 197.81 438.695 184.33 436.354 170.772C434.073 157.56 436.548 146.916 439.229 142.546C445.231 132.763 457.256 126.029 469.864 118.188C487.474 107.235 498.151 106.446 509.238 103.488C529.063 98.1988 563.528 104.587 578.16 107.008C592.07 109.309 602.115 109.414 615.242 119.505C620.742 123.733 626.545 127.642 630.564 134.255C636.032 143.252 634.205 163.251 631.391 177.308C629.565 186.429 621.477 189.6 620.394 193.438C619.873 195.284 622.106 197.19 627.371 198.138C653.145 202.777 679.648 197.594 705.078 199.378C729.678 201.105 747.251 203.793 777.721 208.631C795.254 211.414 812.561 217.942 822.379 222.605C829.211 225.85 834.689 229.989 836.39 233.552C843.211 247.837 793.207 239.407 782.571 241.873C777.02 242.558 771.834 243.014 758.521 243.387C747.382 243.513 727.34 243.513 704.846 244.128",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M254.949 238.514C276.412 240.138 329.442 239.559 350.696 240.098C380.147 240.845 391.866 243.446 451.783 243.753C494.891 243.974 574.12 242.884 620.41 242.398C666.7 241.911 677.65 241.534 690.545 241.239C703.441 240.943 717.95 240.741 732.899 240.531",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5407 80.4626C82.1335 80.4626 85.7262 80.4626 107.367 80.4626C129.008 80.4626 168.588 80.4626 190.092 80.1948C219.347 79.8304 230.005 73.899 236.53 68.369C240.317 65.1593 235.831 58.3078 232.863 54.0461C227.131 45.8138 215.687 44.8758 204.506 44.3167C201.752 44.179 199.744 46.2334 198.474 45.8694C191.46 43.8582 188.741 32.4551 180.53 27.9396C172.698 23.6322 164.801 23.2372 154.541 16.6342C130.903 1.42153 111.995 4.99905 102.538 6.36006C98.8318 6.89337 98.2245 10.4431 98.1903 13.2064C98.1218 18.742 101.54 22.8868 101.349 23.6968C99.414 31.9053 80.9501 17.8493 69.7875 18.5589C65.1633 18.8529 62.8337 20.6877 61.2773 22.7508C58.1315 26.9208 58.3687 34.1896 57.3047 39.3676C56.6557 42.5258 49.1686 37.1982 44.1962 38.2697C41.7856 38.7891 40.3681 41.4841 39.5401 43.7029C37.9582 47.9421 40.0735 52.9682 43.1929 57.6764C48.9094 66.3042 59.6703 67.3692 68.849 70.0748C74.0221 71.2643 78.8827 72.9622 83.0281 74.9782C85.0875 75.8931 87.0573 76.5884 89.0868 77.3048",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M853.214 143.489C858.138 142.997 892.271 142.743 941.403 142.454C961.478 142.335 966.142 140.336 970.345 138.595C972.545 137.683 974.548 135.998 975.087 133.861C976.282 129.121 971.974 124.72 968.577 121.468C960.862 114.082 951.109 113.898 940.138 103.999C930.766 95.542 919.948 94.9294 915.682 96.4261C913.678 97.1291 912.806 99.4 911.544 98.979C907.605 97.6645 905.664 91.8138 901.149 89.6824C895.03 86.7935 888.41 87.6726 884.465 89.5334C880.504 91.4019 881.074 97.8613 879.785 101.149C878.375 104.748 869.645 100.388 863.19 100.924C858.169 101.341 855.59 106.85 852.986 112.039C850.657 116.68 839.742 114.931 830.189 115.287C826.53 115.424 825.573 117.874 825.043 119.943C823.969 124.14 825.252 129.059 827.356 133.246C834.892 137.601 841.433 140.707 845.905 142.007C848.248 142.612 850.74 143.104 853.308 143.611",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M447.521 740.063L445.457 755.322",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M477.014 746.619L483.423 754.184",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M488.927 739.675C489.103 740.026 489.278 740.376 491.391 742.91C493.504 745.444 497.549 750.15 500.211 751.949C502.873 753.749 504.028 752.501 505.219 751.215",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M509.409 742.961C510.358 743.198 511.307 743.435 512.636 744.352C513.966 745.269 515.648 746.858 517.38 748.494",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M526.699 745.117C527.318 745.323 527.936 745.53 528.683 746.549C529.43 747.568 530.287 749.394 531.169 751.276",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M447.785 787.193C447.785 787.812 447.785 788.431 447.476 791.216C447.166 794.001 446.547 798.932 445.909 804.014",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M454.639 794.658C454.989 794.658 455.34 794.658 457.033 796.309C458.725 797.96 461.749 801.262 464.864 804.664",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M473.466 784.643L490.606 796.312",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M502.593 781.793C502.737 781.793 502.882 781.793 504.706 782.897C506.53 784.002 510.029 786.21 513.635 788.486",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M521.265 777.855C524.589 779.714 527.914 781.573 530.463 782.665C533.011 783.756 534.683 784.024 536.405 784.3",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M541.502 778.109L547.161 782.675",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M448.616 841.171L449.054 852.927",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M471.655 831.543C471.655 831.688 471.655 831.832 472.867 834.125C474.08 836.419 476.505 840.856 479.003 845.428",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M491.706 832.819C493.439 835.233 495.172 837.648 497.108 838.592C499.044 839.536 501.129 838.937 503.278 838.32",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M523.04 824.292C523.184 824.437 523.329 824.581 525.013 825.677C526.697 826.773 529.916 828.816 533.233 830.921",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M545.963 819.158C550.405 821.286 554.847 823.414 558.002 824.613C561.157 825.813 562.89 826.019 564.676 826.232",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M572.464 813.41V819.1",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M467.236 877.213L467.955 888.154",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M476.804 880.619C478.146 881.424 479.487 882.229 480.906 883.685C482.324 885.142 483.779 887.226 485.278 889.373",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M490.063 876.113C491.157 876.351 492.251 876.588 494.894 877.84C497.537 879.093 501.696 881.353 505.981 883.682",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M515.93 869.917C519.718 871.888 523.505 873.86 526.343 874.561C529.182 875.261 530.957 874.632 532.785 873.983",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M547.217 856.268C549.177 857.01 551.137 857.753 553.251 858.502C555.365 859.251 557.573 859.984 559.848 860.739",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M584.243 847.276L588.122 848.246",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M484.921 921.19C484.745 921.541 484.57 921.892 484.552 923.336C484.534 924.781 484.678 927.308 484.827 929.912",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M493.086 929.913C497.964 932.321 502.841 934.728 506.376 936.531C509.91 938.334 511.953 939.459 514.058 940.618",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M516.968 917.55L520.94 917.988",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M522.38 905.849C529.808 909.145 537.236 912.441 541.641 913.602C546.045 914.764 547.201 913.69 548.392 912.585",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M552.897 898.822L565.595 901.887",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M579.424 888.934L579.862 889.372",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M520.086 953.939L523.965 955.785",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M540.821 953.315L543.386 953.754",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M551.828 942.311L562.019 943.029",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M561.739 926.05L583.462 929.056",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M581.306 923.365H601.423",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00049 469.663C13.0576 464.436 20.7521 460.325 29.552 458.651C50.461 454.675 56.2284 468.312 59.6853 471.856C61.6291 473.849 64.8019 467.886 67.2942 465.194C84.2561 468.426 112.137 478.611 118.635 479.353C121.217 479.242 122.345 478.14 125.57 474.863",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7148 456.394C33.2787 454.151 35.1104 445.654 39.2739 437.896C43.8918 429.292 50.2706 419.337 55.2941 413.181C59.5769 407.933 70.0634 404.986 78.2031 403.99C84.8006 403.183 91.6183 399.607 96.6872 399.181C102.255 398.712 98.2222 411.238 97.8251 417.485C97.7323 418.944 97.1661 420.171 102.036 420.793C106.907 421.415 117.1 421.381 122.351 422.63C127.602 423.878 127.602 426.411 127.443 428.327C126.952 434.234 125.03 442.829 119.812 455.007C115.586 461.549 111.494 465.469 109.285 467.27C108.179 468.142 107.102 468.925 104.451 471.718",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4681 436.832C68.2267 436.832 66.6892 436.539 64.4749 435.397C62.3099 434.281 63.3764 428.029 63.9968 422.31C64.226 420.197 65.8579 420.01 67.5738 420.044C71.4607 420.123 75.0393 421.812 77.4327 423.929C79.474 425.734 79.69 429.559 79.2032 433.604C78.7164 435.34 77.7427 436.434 76.6553 437.304C75.5679 438.173 74.3962 438.785 71.2041 439.781",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2627 453.742C71.2627 453.984 73.4161 455.943 77.833 459.248C80.0965 460.719 82.4049 461.77 84.2056 462.384C86.0063 462.999 87.2295 463.145 89.3772 463.296",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M894.581 461.239C895.115 460.17 896.829 458.327 899.715 456.223C906.94 450.955 921.086 454.282 927.19 450.746C935.025 446.207 938.279 438.544 942.204 434.351C946.535 429.725 953.351 425.791 961.554 421.753C967.556 418.799 972.596 416.666 979.253 415.451C984.288 414.532 979.415 405.121 980.182 401.127C981.283 395.392 995.096 404.044 1002.4 407.33C1007.48 409.612 1013.58 410.73 1024.26 410.81C1032 410.868 1037.7 414.196 1041.89 417.047C1048.85 421.781 1035.77 429.686 1034.01 433.652C1031.67 438.904 1045.64 436.39 1048.68 437.715C1050.06 438.32 1050.42 440.021 1050.25 442.169C1049.51 451.657 1043.25 455.499 1038.25 459.773C1033.65 463.713 1027.15 466.986 1020.32 470.318C1013.64 473.577 1002.9 475.076 995.792 476.573C987.648 478.287 976.78 478.311 966.637 478.744C953.635 479.3 944.05 478.032 941.929 477.95C934.746 477.673 935.781 489.44 930.642 494.211C925.106 499.351 920.415 502.77 917.462 504.845C916.124 505.786 915.129 506.525 914.106 505.041C907.956 496.122 908.294 489.954 907.364 483.843C906.922 480.943 905.647 478.498 904.333 476.289C901.508 471.541 888.66 470.483 879.77 468.134C876.159 467.18 873.109 466.248 872.618 465.264C875.796 463.978 880.024 463.018 883.296 462.532C884.932 462.27 886.517 461.977 891.701 461.676",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.26 437.649C1004.48 436.986 1000.41 433.357 998.812 429.201C998.126 427.415 998.888 425.932 999.714 424.847C1001.35 422.699 1004.14 421.983 1006.77 421.711C1009.73 421.405 1012.42 423.19 1014.41 424.89C1018.48 428.362 1017.12 434.371 1016.73 436.96C1016.34 438.152 1015.56 439.1 1014.51 439.709C1013.45 440.318 1012.14 440.56 1010.79 440.808",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M980.04 439.376C972.42 443.479 964.461 449.162 963.796 451.713C963.455 453.016 963.569 454.436 964.168 455.569C964.767 456.701 965.964 457.528 969.518 457.954C973.072 458.38 978.947 458.38 986.984 458.302",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaver14);
export default __webpack_public_path__ + "static/media/beaver14.4a20fa92ff77038effdb281d75ac7e9b.svg";
export { ForwardRef as ReactComponent };